export default "/_next/static/node_modules/@riot-private/blades-ui/dist/skins/2xkov2/assets/carousel-left.svg";